var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "stock-dialog" },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: true,
              expression: "true"
            }
          ],
          attrs: {
            "close-on-click-modal": false,
            title: "",
            "append-to-body": true,
            center: "",
            width: "30%",
            visible: _vm.stockDialogVisable
          },
          on: {
            "update:visible": function($event) {
              _vm.stockDialogVisable = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "stockDialogForm",
              staticClass: "stock-dialog-form",
              attrs: {
                rules: _vm.stockRules,
                model: _vm.stockDialogForm,
                "status-icon": ""
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "数量", prop: "change_stock_num" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.stockDialogForm.change_stock_num,
                      callback: function($$v) {
                        _vm.$set(_vm.stockDialogForm, "change_stock_num", $$v)
                      },
                      expression: "stockDialogForm.change_stock_num"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "待审核价格", prop: "new_price" } },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.is_deposit == "1" },
                    on: { change: _vm.changePrice },
                    model: {
                      value: _vm.stockDialogForm.new_price,
                      callback: function($$v) {
                        _vm.$set(_vm.stockDialogForm, "new_price", $$v)
                      },
                      expression: "stockDialogForm.new_price"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.is_deposit == "1"
                ? _c("span", { staticClass: "deposit_tips" }, [
                    _vm._v("注：该商品为定金购商品，暂不支持改价")
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeStockDialog } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveStock } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7776d448", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7776d448","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stock/stock-dialog.vue
// module id = null
// module chunks = 